export default "__VITE_ASSET__CAU9UsXn__"